import { render, staticRenderFns } from "./PassengerInfoCard.vue?vue&type=template&id=58a7a774&scoped=true&"
import script from "./PassengerInfoCard.vue?vue&type=script&lang=js&"
export * from "./PassengerInfoCard.vue?vue&type=script&lang=js&"
import style0 from "./PassengerInfoCard.vue?vue&type=style&index=0&id=58a7a774&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58a7a774",
  null
  
)

export default component.exports